import dayjs from 'dayjs';

export interface ISectorCalendar {
  id?: number;
  day?: dayjs.Dayjs | null;
}

export const defaultValue: Readonly<ISectorCalendar> = {};
